// Note: Location options are now MNO-specific and available via the useMnoContext() hook
// See src/context/mno/configs/ for MNO-specific configurations

export const DEFAULT_DATE_FORMAT = 'dd-MM-yyyy'
  